import React from 'react';
import { Button } from '../../ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

interface WelcomeStepProps {
  onNext: () => void;
}

export function WelcomeStep({ onNext }: WelcomeStepProps) {
  return (
    <div className="text-center space-y-8">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-prosigliere-blue/10 mb-4">
        <Sparkles className="w-10 h-10 text-prosigliere-blue" />
      </div>

      <div className="space-y-4">
        <h1 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight">
          Let's get to know you
        </h1>
        <p className="text-xl text-muted-foreground max-w-md mx-auto leading-relaxed">
          We're excited to have you here. Tell us a bit about yourself so we can personalize your experience.
        </p>
      </div>

      <div className="pt-4">
        <Button size="lg" onClick={onNext} className="group text-lg px-8 py-6 rounded-full">
          Get Started
          <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
        </Button>
      </div>

      <p className="text-sm text-muted-foreground">This will only take a few minutes</p>
    </div>
  );
}
